export default {
    'invoice-no': 'رقم الفاتورة',
    new: 'جديد',
    delete: 'حذف',
    account: 'الحساب',
    'invoice-date': 'تاريخ الفاتورة',
    warehouse: 'المستودع',
    document: 'المستند',
    'net-invoice': 'صافي الفاتورة',
    save: 'حفظ',
    edit: 'تعديل',
    not: 'غير',
    posted: 'مُرحّلة',
    'add-invoice': 'إضافة فاتورة',
    create: 'إنشاء',
    cancel: 'إلغاء',

    'delete-entry': 'حذف سطر',
    'are-you-sure-you-want-to-delete-the-entry': 'هل أنت متأكد من حذف السطر؟',
    
    'delete-invoice': 'حذف الفاتورة',
    'are-you-sure-you-want-to-delete-the-invoice-that-will-delete-the-associated-bond': 'هل أنت متأكد من حذف الفاتورة سيتم حذف السند المُرتبط أيضاً؟',
    notes: 'ملاحظات',
    discount: 'الحسم',
    total: 'الإجمالي',

    headers: {
        no: 'الرقم',
        warehouse: 'المستودع',
        material: 'المادة',
        quantity: 'الكمية',
        count: 'العدد',
        price: 'السعر',
        'discount-percentage': 'نسبة الحسم',
        'discount': 'الحسم',
        'after-discount': ' صافي القيمة',
        'notes': 'الملاحظات',
    },

    'context-menu': {
        edit: 'تعديل',
        delete: 'حذف'
    },
    receivables: 'المقبوضات',
    'total-receipts': 'مجموع المقبوضات',
    'alert-message': 'رسالة تنبيه',
    'confirm-message': 'أصبح مجموع المقبوضات أكبر من الإجمالي. هل تريد المتابعة ؟'
}